module.exports = __webpack_public_path__ + "static/media/nsglogosite.2c2d5a5e.png";